import { convertJsonApiDataToModelData } from "@services/save-resource-to-store/convert-json-api-data-to-model-data.js";
import saveModelDataToStore from "@services/save-resource-to-store/save-model-data-to-store.js";

export const saveJsonApiDataToStore = (
  storeRegistry: Record<string, unknown>,
  jsonApiData: unknown,
) => {
  saveModelDataToStore(
    storeRegistry,
    convertJsonApiDataToModelData(jsonApiData),
  );
};
